exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desc[data-v-2cf9cbc1]{color:#999;font-size:12px;margin:0}", ""]);

// exports
